module.exports = __webpack_public_path__ + "img/th-box4-text-dark.ac3fd5e4.png";